import * as React from 'react';
import { useEffect, useReducer } from 'react';
import { Modal, FormGroup, Label, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

import GenericDropdownAsync from '../../components/controls/GenericDropdownAsync';
import * as AuthorizationStore from '../../store/Authorization';
import CartService from '../../services/CartService';
import { ShoppingCart } from '../../models/ShoppingCart';
import CreateNewCartModal from '../ProductSearch/CreateNewCartModal';

type State = {
    selectedCart: ShoppingCart,
    openCreateCartDlg: boolean
}

const initialState: State = {
    selectedCart: undefined,
    openCreateCartDlg: false
}

function SelectCartModal(props: {
    open: boolean,
    userId: any,
    cartToExclude: ShoppingCart,
    addCreateCartOption: boolean,
    onCancel: () => void,
    onSave: (cart: ShoppingCart) => void
}) {

    let [state, setState] = useReducer(
        (prevState: State, newState: Partial<State>) => ({ ...prevState, ...newState }),
        initialState
    );

    useEffect(() => {
        
    }, [])

    const cancel = () => {
        setState({ selectedCart: undefined });
        props.onCancel();
    }

    const save = () => {
        props.onSave(state.selectedCart);
        setState({ selectedCart: undefined });
    }

    const addNewCart = (name: string) => {
        const selectedCart = {
            CartId: undefined, CartName: name, UserId: props.userId
        };

        props.onSave(selectedCart);

        setState({
            openCreateCartDlg: false,
            selectedCart: undefined
        })
    }
    const partner = AuthorizationStore.getImpactPartnerFromLocalStorage();

    const cartIdToExclude = props.cartToExclude ? props.cartToExclude.CartId : undefined;

    return <>
        <Modal backdrop={'static'} isOpen={props.open} toggle={props.onCancel} size="md" className="modal-dialog-centered">
            <ModalHeader className="modal-header">
                <h5 className="modal-title">Select Cart</h5>
                <button type="button" className="close" aria-label="Close" onClick={cancel}><span aria-hidden="true"><i className="fa fa-times"></i></span></button>
            </ModalHeader>
            <ModalBody>
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                    <Label className="mr-sm-2">
                        Select Cart
                    </Label>
                    <GenericDropdownAsync
                        loadDataSource={() => CartService.getLookupCarts(props.userId, partner ? partner.Id : undefined, cartIdToExclude, props.addCreateCartOption)}
                        getId={x => x.CartId}
                        renderItem={x => x.CartName}
                        renderSelectedItem={x => x ? x.CartName : ''}
                        allowNullSelection={true}
                        nullSelectionText='Select Cart'
                        selectedValue={state.selectedCart ? state.selectedCart.CartId : undefined}
                        onSelectedItemChanged={x => {

                            setState({ selectedCart: x });

                            if (x && x.CartId === "-1") {
                                setState({ openCreateCartDlg: true });
                            }
                        }}
                    />
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <div className="w-100 d-flex">
                    <Button color="white" className="mr-2 flex-fill" onClick={cancel}>Cancel</Button>
                    <Button color="white" className="btn btn-black d-inline-block border flex-fill"
                        onClick={save}
                        disabled={state.selectedCart === undefined}>Save</Button>
                </div>
            </ModalFooter>
        </Modal>
        {
            <CreateNewCartModal open={state.openCreateCartDlg}
                onCancel={() => setState({
                    openCreateCartDlg: false,
                    selectedCart: undefined
                })}
                onAdd={addNewCart}
            />
        }
    </>

}

export default SelectCartModal;
